import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest, postRequest, putRequest } from "../../services";
import {
  decryptMessage,
  encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";

export const getInventoryData = createAsyncThunk(
  "Inventory/Main inventory",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getInventoryItemsData = createAsyncThunk(
  "Inventory/Inventory items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getIssuesNamesData = createAsyncThunk(
  "Inventory/issued users",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getIssuedItemsData = createAsyncThunk(
  "Inventory/issued Items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getIssuesItemsData = createAsyncThunk(
  "Inventory/issued items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getIssueInventoryItemsData = createAsyncThunk(
  "Inventory/Issue inventory items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getAvailableItems = createAsyncThunk(
  "Inventory/available inventory items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getReturnInventoryItemsData = createAsyncThunk(
  "Inventory/return inventory items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getDiscaredInventoryItemsData = createAsyncThunk(
  "Inventory/discarded inventory items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getRepairInventoryItemsData = createAsyncThunk(
  "Inventory/repaired inventory items",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const availableInventory = createAsyncThunk(
  "Inventory/available quantity",
  async ({ endPoint, data }: { endPoint: string; data: string }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const getSubCategory = createAsyncThunk(
  "Inventory/issued to and return by",
  async ({ endPoint, data }: { endPoint: string; data: any }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
export const addIssueInventory = createAsyncThunk(
  "Inventory/add issue inventory",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };

    return putRequest(endPoint, putData)
      .then((res) => {
        const data =
          process.env.NODE_ENV === "development"
            ? res.data
            : decryptMessage(JSON.stringify(res.data));
        toaster("success", data.message);
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const addReturnInventory = createAsyncThunk(
  "Inventory/add return inventory",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => {
        const data =
          process.env.NODE_ENV === "development"
            ? res.data
            : decryptMessage(JSON.stringify(res.data));
        toaster("success", data.message);
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
export const updateItemCondition = createAsyncThunk(
  "Inventory/update item condition",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => {
        const data =
          process.env.NODE_ENV === "development"
            ? res.data
            : decryptMessage(JSON.stringify(res.data));
        toaster("success", data.message);
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const putData = createAsyncThunk(
  "UI/chnagePassword",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);
//------for steel reconciliation----
export const getSteelReconciliation = createAsyncThunk(
  "Inventory/get-overall-steel-reconciliation",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getSteelReconciliationById = createAsyncThunk(
  "Inventory/get-steel-reconciliation-byId",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getSteelReconciliationByProject = createAsyncThunk(
  "Inventory/get-steel-reconciliation-byProject",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error(err);
      });
  }
);
type SliceState = {
  loading: boolean;
  inventoryData: null | "" | Object;
  inventoryItemsData: null | "" | Object;
  issueInventoryItemsData: null | "" | Object;
  returnInventoryItemsData: null | "" | Object;
  discardedInventoryItemsData: null | "" | Object;
  repairInventoryItemsData: null | "" | Object;
  availableItemNames: null | "" | Object;
  issuedUsers: null | "" | Object;
  issuedItems: null | "" | Object;
  availableInventory: null | "" | number;
  subCategoryData: null | "" | number;
  steelReconciliationData: null | "" | number;
  steelReconciliationDataById: null | "" | number;
  steelReconciliationDataByProject: null | "" | number;
};

const initialState: SliceState = {
  loading: false,
  inventoryData: "",
  inventoryItemsData: "",
  issueInventoryItemsData: "",
  returnInventoryItemsData: "",
  discardedInventoryItemsData: "",
  repairInventoryItemsData: "",
  availableItemNames: "",
  issuedUsers: "",
  issuedItems: "",
  availableInventory: 0,
  subCategoryData: "",
  steelReconciliationData: "",
  steelReconciliationDataById: "",
  steelReconciliationDataByProject: "" 
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setFilterHistory(state, action) {
      state.inventoryData = action.payload;
    },
    setAvailableItems(state, action) {
      state.inventoryItemsData = action.payload;
    },
    setIssuedInventoryItems(state, action) {
      state.issueInventoryItemsData = action.payload;
    },
    setReturnInventoryItems(state, action) {
      state.returnInventoryItemsData = action.payload;
    },
    setDiscardedInventoryItems(state, action) {
      state.discardedInventoryItemsData = action.payload;
    },
    setRepairInventoryItems(state, action) {
      state.repairInventoryItemsData = action.payload;
    },
    setAvailableQuantity(state, action) {
      state.availableInventory = action.payload;
    },
    setInitSteelReconciliationDataById(state) {
      state.steelReconciliationDataById = "";
    }
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getInventoryData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInventoryData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.inventoryData = data?.data;
      } else {
        state.inventoryData = [];
        console.log(data?.status);
      }
    });
    builder.addCase(getInventoryData.rejected, (state) => {
      state.loading = true;
    });
    builder.addCase(getIssuesNamesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getIssuesNamesData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.issuedUsers = data?.data;
      } else {
        state.issuedUsers = "";
        console.log(data?.status);
      }
    });
    builder.addCase(getIssuesNamesData.rejected, (state) => {
      state.loading = true;
    });
    builder.addCase(getIssuedItemsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getIssuedItemsData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.issuedItems = data?.data;
      } else {
        state.issuedItems = "";
        console.log(data?.status);
      }
    });
    builder.addCase(getIssuedItemsData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL START
    builder.addCase(getInventoryItemsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getInventoryItemsData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.inventoryItemsData = data?.data;
      } else {
        state.inventoryItemsData = [];
      }
    });
    builder.addCase(getInventoryItemsData.rejected, (state) => {
      state.loading = true;
    });

    builder.addCase(getIssueInventoryItemsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getIssueInventoryItemsData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.issueInventoryItemsData = data?.data[0].list;
      } else {
        state.issueInventoryItemsData = [];
      }
    });
    builder.addCase(getIssueInventoryItemsData.rejected, (state) => {
      state.loading = true;
    });

    builder.addCase(getReturnInventoryItemsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getReturnInventoryItemsData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.returnInventoryItemsData = data?.data[0].list;
      } else {
        state.returnInventoryItemsData = [];
      }
    });
    builder.addCase(getReturnInventoryItemsData.rejected, (state) => {
      state.loading = true;
    });

    builder.addCase(availableInventory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(availableInventory.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.availableInventory = data?.data[0]?.TotalQuantity;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(availableInventory.rejected, (state) => {
      state.loading = true;
    });
    builder.addCase(getDiscaredInventoryItemsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getDiscaredInventoryItemsData.fulfilled,
      (state, action) => {
        state.loading = false;
        const data: any =
          process.env.NODE_ENV === "development"
            ? action.payload?.data
            : decryptMessage(JSON.stringify(action.payload?.data));
        if (data?.status) {
          state.discardedInventoryItemsData = data?.data[0].list;
        } else {
          state.discardedInventoryItemsData = [];
        }
      }
    );
    builder.addCase(getDiscaredInventoryItemsData.rejected, (state) => {
      state.loading = true;
    });

    builder.addCase(getRepairInventoryItemsData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRepairInventoryItemsData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.repairInventoryItemsData = data?.data[0]?.list;
      } else {
        state.repairInventoryItemsData = [];
      }
    });
    builder.addCase(getRepairInventoryItemsData.rejected, (state) => {
      state.loading = true;
    });
    builder.addCase(getAvailableItems.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAvailableItems.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.availableItemNames = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getAvailableItems.rejected, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubCategory.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.subCategoryData = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getSubCategory.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL START
    builder.addCase(getSteelReconciliation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSteelReconciliation.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.steelReconciliationData = data?.data;
      } else {
        console.log(data?.status);
        state.steelReconciliationData = data?.data;
      }
    });
    builder.addCase(getSteelReconciliation.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    
    //TODO: Get API CALL START
    builder.addCase(getSteelReconciliationById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSteelReconciliationById.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.steelReconciliationDataById = data?.data;
      } else {
        console.log(data?.status);
        state.steelReconciliationDataById = data?.data;
      }
    });
    builder.addCase(getSteelReconciliationById.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getSteelReconciliationByProject.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSteelReconciliationByProject.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.steelReconciliationDataByProject = data?.data;
      } else {
        console.log(data?.status);
        state.steelReconciliationDataByProject = data?.data;
      }
    });
    builder.addCase(getSteelReconciliationByProject.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END
  },
});


export const {
  setFilterHistory,
  setAvailableItems,
  setIssuedInventoryItems,
  setReturnInventoryItems,
  setDiscardedInventoryItems,
  setRepairInventoryItems,
  setAvailableQuantity,
  setInitSteelReconciliationDataById,
} = inventorySlice.actions;

export default inventorySlice;
